export const MARKETPLACE_LIST_REQUEST = "MARKETPLACE_LIST_REQUEST";
export const MARKETPLACE_LIST_SUCCESS = "MARKETPLACE_LIST_SUCCESS";
export const MARKETPLACE_LIST_ERROR = "MARKETPLACE_LIST_ERROR";
